export default "__VITE_ASSET__93e7cca9__"